export function scrollToFirstFieldError(fieldIds: string[]) {
  requestAnimationFrame(() => {
    for (const id of fieldIds) {
      const el = document.getElementById(`field-${id}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        break
      }
    }
  })
}

export function invalidFieldsFromChecks(checks: Record<string, boolean>): Set<string> {
  return new Set(Object.entries(checks).filter(([, valid]) => !valid).map(([key]) => key))
}
